import notification from "antd/lib/notification";
import Form from "antd/lib/form";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser, GetUser } from "../services/NewAuthService";

import { getImageBaseUrl } from "../services/s3-utils";
import { useQalortSession } from "../hooks/useQalortSession";
import { updateUserSlice } from "../store/slices/userSlice";
import { useDispatch } from "react-redux";
import QalortButton from "../components/Button";
import MetisAxios from "../services/Axios";
import SEO from "../components/Seo";
import { useCookies } from "react-cookie";
import { qalort_token, tokenOptions } from "../components/menu/constant";

function Login(props) {
  const [cookies, setCookie] = useCookies([qalort_token]);
  const [pwrdType, setPwrdType] = useState(true);
  const [loading, setLoading] = useState(false);
  const { qalortUser } = useQalortSession();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let params = new URLSearchParams(window.location.search);
  const returnUrl = params.get("returnUrl");
  let signUpUrl = "/signup";
  if (returnUrl) {
    signUpUrl = `/signup?returnUrl=${returnUrl}`;
  }

  const onSubmit = async (values) => {
    const { email, password } = values;
    const data = { email: email.toLowerCase(), password };

    try {
      setLoading(true);
      const response = await loginUser(data);
      const token = response.data.meta.token;
      localStorage.setItem("qalort_token", token);
      MetisAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
      // Set a cookie with the token
      setCookie(qalort_token, token, tokenOptions);
      getMe(token, response.data.data, response.data.data);
    } catch (error) {
      notification.error({
        description: error.message || "An error occurred. Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const getMe = (token, userInfo) => {
    const req = GetUser(token);
    req.then((res) => {
      let data = res.data;
      const payload = {
        ...userInfo,
        ...data.data,
        full_name: `${data?.data?.first_name} ${data?.data?.last_name}`,
        token,
      };
      dispatch(updateUserSlice(payload));
      if (returnUrl) {
        navigate(returnUrl);
      } else if (data?.data?.user_type === "learner") {
        navigate("/mentors");
      } else {
        navigate("/dashboard");
      }
    });
  };

  useEffect(() => {
    qalortUser && navigate("/");
  }, []);

  return (
    <>
      <SEO />
      <div className="flex [@media(min-width:987px)]:p-4 h-screen overflow-hidden">
        <div className="w-[41%] h-full bg-pri-tint flex items-center justify-center relative [@media(max-width:986px)]:hidden">
          <Link to="/">
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="absolute top-8 left-8"
              alt=""
            />
          </Link>
          <img
            src={`${getImageBaseUrl}/assets/auth.png`}
            className="w-2/3 hidden md:block"
            alt=""
          />
        </div>
        <div className="flex-1 px-5 [@media(max-width:986px)]:pt-4 [@media(min-width:1200px)]:px-20 pt-[92px] [@media(min-width:1330px)]:pl-[146px] [@media(min-width:1330px)]:pr-[135px] h-full overflow-auto mb-20">
          <Link
            to="/"
            className="hidden [@media(max-width:986px)]:flex border-b border-neutral py-4 mb-[34px] pl-5 pr-5 -ml-5 -mr-5"
          >
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="h-8 w-[103px]"
              alt=""
            />
          </Link>
          <div className="text-tint absolute top-0 right-0 flex items-center pt-10 [@media(max-width:986px)]:hidden">
            <span>Don’t have an account?</span>
            <Link to="/signup">
              <button className="mx-0 md:mx-4 ml-2 bg-pri-tint-3 border-2 bg-white text-tint text-xs py-2 px-4 flex items-center rounded-md border-pri">
                Sign Up
              </button>
            </Link>
          </div>
          <h1 className="mx-auto text-2xl font-semibold text-dark">
            Welcome back 🙌
          </h1>
          <h3 className="mb-10 text-sm mx-auto text-tint font-light">
            Enter your login credentials to get started
          </h3>
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form mt3"
            onFinish={onSubmit}
          >
            <div className="w-full mt-5">
              <p className="label mb-1 text-main">Email</p>
              <div className="flex relative w-full">
                <Form.Item
                  className="w-full h-12"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email address!",
                    },
                  ]}
                >
                  <input
                    id="email"
                    type="email"
                    className="absolute left-0 top-0 z-10 main-input h-12 rounded-md w-full focus:outline-none px-3"
                  />
                </Form.Item>
              </div>

              <div className="w-full mt-5">
                <p className="label mb-1 text-main">Password</p>
                <div className="flex relative w-full">
                  <Form.Item
                    className="w-full"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <input
                      id="password"
                      type={pwrdType ? "password" : "text"}
                      className="main-input h-12 w-full rounded-md focus:outline-none px-3"
                    />
                  </Form.Item>
                  <img
                    onClick={() => setPwrdType(!pwrdType)}
                    src={`${getImageBaseUrl}/assets/eye.svg`}
                    className="absolute top-3 right-4 pointer z-20"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <Link to="/forgot-password">
              <p className="pri mt-4">Forgotten your password?</p>
            </Link>

            <QalortButton
              id="login_btn"
              htmlType="submit"
              className="bg-pri px-5 py-4 rounded-lg text-white w-full mt-4 "
              type="primary"
              loading={loading}
            >
              Sign in
            </QalortButton>
          </Form>
          <p className="text-light text-base leading-[29px] mt-6">
            {" "}
            <span>Don’t have an account?</span>{" "}
            <Link to={signUpUrl}>
              <button className="pri ">Sign Up</button>
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;
